<div class="container mx-auto mb-[2rem]">
  <div class="flex clickable-card-parent flex-wrap justify-center gap-4">
    @for(item of options.controls; track $index) {
    <div
      class="clickable-card dependency flex flex-col justify-center w-full text-center items-center cursor-pointer"
      [ngClass]="item.controls.selected.value ? 'active' : 'inactive'"
      (click)="handleClickOnItem(item.controls.key.value)">
      <div class="flex flex-row items-center place-content-between px-6 py-12">
        <p class="text-clickable-card">
          {{ item.controls.label.value }}
        </p>
      </div>
    </div>
    }
  </div>
</div>
<app-info-bottom [popUpInfo]="popUpInfo"></app-info-bottom>
<app-web-callback-popup [show]="displayModal" (cancel)="cancel()"></app-web-callback-popup>
